import React from "react";
import { toggleSidebar } from "../../utils/sidebarToggle";

function PageHeader() {
  return (
    <div className="mainHead d-flex align-items-center justify-content-between pt-3 py-3">
      <div className="headText ms-3">
        <h2 className="mb-0">📖 Customer Ledger</h2>
      </div>
      <div className="headIcons d-flex me-3">
        <div className="iconMain">
          <i className="fa-solid fa-search"></i>
        </div>
        <div className="iconMain ms-3 me-3">
          <i className="fa-solid fa-exclamation"></i>
        </div>
        <div className="iconMain" onClick={toggleSidebar}>
          <i className="fa-solid fa-bars"></i>
        </div>
      </div>
    </div>
  );
}

export default PageHeader;
